export const additionalSearchSteps = ["initial", "name", "age", "state"];

export const FUNNEL_STEP = {
  QUESTIONNAIRE: "QUESTIONNAIRE",
  LOADER: "LOADER",
  OTP: "OTP",
  RESULTS: "RESULTS",
  LOADING_RESULTS: "LOADING_RESULTS",
  EMAIL_RESULTS: "EMAIL_RESULTS",
  PRE_CHECKOUT_PROTECTION_PLANS: "PRE_CHECKOUT_PROTECTION_PLANS",
  INTERMEDIATE_QUESTION_SCREEN: "INTERMEDIATE_QUESTION_SCREEN",
  NOT_YOU: "NOT_YOU",
  PAYMENT: "PAYMENT",
  SUCCESS: "SUCCESS",
};
